import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import CaptainModal from '../../../Components/CaptainModal';
import { IAssesmentPayload } from '../helpers/typings';
import { cruAssessment, getNewAssessmentObject } from '../helpers/utils';
import AssessmentDataJsonModal from './AssessmentDataJsonModal';

type BasicDataFormProps = {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: (payload: IAssesmentPayload, mode: 'create' | 'edit') => void;
    selectedAssessment?: IAssesmentPayload;
    isDuplicating?: boolean;
};

const BasicDataForm: React.FC<BasicDataFormProps> = ({
    isOpen,
    onClose,
    onSuccess,
    selectedAssessment,
    isDuplicating,
}) => {
    const [assessmentState, setAssessmentState] = useState<IAssesmentPayload>(
        () => {
            if (selectedAssessment) {
                if (isDuplicating) {
                    return {
                        ...selectedAssessment,
                        id: '',
                        name: `${selectedAssessment.name} (Copy)`,
                        data: {
                            ...selectedAssessment.data,
                            id: '',
                        },
                    };
                }
                return selectedAssessment;
            } else {
                return getNewAssessmentObject();
            }
        },
    );

    const [dateError, setDateError] = useState<string>('');
    const [openJsonEditor, setOpenJsonEditor] = useState(false);

    // useEffect(() => {
    //     console.log('assessmentState', assessmentState);
    // }, [assessmentState]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (e: any) => {
        e.preventDefault();

        // Validate automate_wa_reg1 and automate_wa_reg1_enddate
        if (assessmentState.data?.automate_wa_reg1 && !assessmentState.data?.automate_wa_reg1_enddate) {
            setDateError('Please select an end date for Automate Registration WA');
            return;
        }

        setDateError('');
        // Submit logic
        cruAssessment(assessmentState, onSuccess);
        onClose();
    };

    // {
    //     id: '',
    //     data: {
    //         id: '',
    //         ismandatory: false,
    //         successCopy: '',
    //         screens: [],
    //         buttonCopies: {
    //             START: '',
    //             SUBMIT: '',
    //             NEXT: '',
    //         },
    //         onCompleteAction: '',
    //     },
    //     istest: false,
    //     for_discussion: false,
    //     discussionid: '',
    //     preorpost: 'pre',
    //     name: '',
    // }

    return (
        <CaptainModal isOpen={isOpen} onClose={onClose}>
            <div className="text-center fw-bold fs-4 mb-3">
                {selectedAssessment && !isDuplicating
                    ? 'Edit Assessment'
                    : 'Add Assessment'}
            </div>

            <Form className="mb-3 mx-3" onSubmit={handleSubmit}>
                {/* Assessment Name input */}
                <div className="mb-3 d-flex flex-column gap-1">
                    <label htmlFor="name" className="mb-0">
                        Assessment Name:
                    </label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        className="p-2"
                        placeholder="Enter name of the assessment"
                        value={assessmentState?.name}
                        onChange={e => {
                            setAssessmentState(prev => ({
                                ...prev,
                                name: e.target.value,
                            }));
                        }}
                    />
                </div>

                {/* is test */}
                <div className="mb-3 d-flex flex-row align-items-center gap-2">
                    <label htmlFor="isTest" className="mb-0">
                        Is It Test ?
                    </label>
                    <Form.Check
                        className="mb-0"
                        type="switch"
                        id="isTest"
                        name="isTest"
                        label=""
                        checked={assessmentState?.istest}
                        onChange={e => {
                            setAssessmentState({
                                ...assessmentState,
                                istest: e.target.checked,
                            });
                        }}
                    />
                </div>

                {/* for discussion */}
                <div className="mb-3 d-flex flex-row align-items-center gap-2">
                    <label htmlFor="forDiscussion" className="mb-0">
                        For Discussion ?
                    </label>
                    <Form.Check
                        className="mb-0"
                        type="switch"
                        id="forDiscussion"
                        name="forDiscussion"
                        label=""
                        checked={assessmentState?.for_discussion}
                        onChange={e => {
                            setAssessmentState(prev => ({
                                ...prev,
                                for_discussion: e.target.checked,
                            }));
                        }}
                    />
                </div>

                {/* discussion id */}
                {assessmentState.for_discussion && (
                    <div className="mb-3 d-flex flex-column gap-1">
                        <label htmlFor="discussionId" className="mb-0">
                            Discussion ID:
                        </label>
                        <input
                            type="text"
                            id="discussionId"
                            name="discussionId"
                            className="p-2"
                            placeholder="Enter discussion ID"
                            required
                            value={assessmentState?.discussionid}
                            onChange={e => {
                                setAssessmentState(prev => ({
                                    ...prev,
                                    discussionid: e.target.value,
                                }));
                            }}
                        />
                    </div>
                )}

                {/* pre or post - radio */}
                <div className="d-flex gap-2 align-items-center mb-3">
                    <input
                        type="radio"
                        id="pre"
                        name="preOrPost"
                        value="pre"
                        className="p-2"
                        checked={assessmentState?.preorpost === 'pre'}
                        onChange={e => {
                            setAssessmentState(prev => ({
                                ...prev,
                                preorpost: e.target.value as 'pre' | 'post',
                            }));
                        }}
                    />
                    <label htmlFor="pre" className="me-2 mb-0">
                        Pre
                    </label>
                    <input
                        type="radio"
                        id="post"
                        name="preOrPost"
                        value="post"
                        className="p-2"
                        checked={assessmentState?.preorpost === 'post'}
                        onChange={e => {
                            setAssessmentState(prev => ({
                                ...prev,
                                preorpost: e.target.value as 'pre' | 'post',
                            }));
                        }}
                    />
                    <label htmlFor="post" className="mb-0">
                        Post
                    </label>
                </div>

                {/* Is Mandatory */}
                <div className="mb-3 d-flex flex-row align-items-center gap-2">
                    <label htmlFor="isMandatory" className="mb-0">
                        Is Mandatory ?
                    </label>
                    <Form.Check
                        className="mb-0"
                        type="switch"
                        id="isMandatory"
                        name="isMandatory"
                        label=""
                        checked={assessmentState?.data?.ismandatory}
                        onChange={e => {
                            setAssessmentState(prev => ({
                                ...prev,
                                data: {
                                    ...prev.data,
                                    ismandatory: e.target.checked,
                                },
                            }));
                        }}
                    />
                </div>

                {/* Automate Registration WA */}
                <div className="mb-3 d-flex flex-row align-items-center gap-2">
                    <label htmlFor="automateWaReg" className="mb-0">
                        Automate Registration WA ?
                    </label>
                    <Form.Check
                        className="mb-0"
                        type="switch"
                        id="automateWaReg"
                        name="automateWaReg"
                        label=""
                        checked={assessmentState?.data?.automate_wa_reg1 || false}
                        onChange={e => {
                            setDateError('');
                            setAssessmentState(prev => ({
                                ...prev,
                                data: {
                                    ...prev.data,
                                    automate_wa_reg1: e.target.checked,
                                },
                            }));
                        }}
                    />
                </div>

                {/* Automate Registration WA End Date */}
                {assessmentState?.data?.automate_wa_reg1 && (
                    <div className="mb-3 d-flex flex-column gap-1">
                        <label htmlFor="automateWaRegEndDate" className="mb-0">
                            Automate Registration WA Until:
                        </label>
                        <input
                            type="date"
                            id="automateWaRegEndDate"
                            name="automateWaRegEndDate"
                            className={`p-2 ${dateError ? 'border-danger' : ''}`}
                            value={assessmentState?.data?.automate_wa_reg1_enddate || ''}
                            onChange={e => {
                                setDateError('');
                                setAssessmentState(prev => ({
                                    ...prev,
                                    data: {
                                        ...prev.data,
                                        automate_wa_reg1_enddate: e.target.value,
                                    },
                                }));
                            }}
                        />
                        {dateError && (
                            <div className="text-danger small mt-1">{dateError}</div>
                        )}
                    </div>
                )}

                {/* Success Text */}
                <div className="mb-3 d-flex flex-column gap-1">
                    <label htmlFor="successCopy" className="mb-0">
                        Success Text:
                    </label>
                    <input
                        type="text"
                        id="successCopy"
                        name="successCopy"
                        className="p-2"
                        placeholder="Enter success text"
                        value={assessmentState?.data?.successCopy}
                        onChange={e => {
                            setAssessmentState(prev => ({
                                ...prev,
                                data: {
                                    ...prev.data,
                                    successCopy: e.target.value,
                                },
                            }));
                        }}
                    />
                </div>

                {/* Start button text */}
                <div className="mb-3 d-flex flex-column gap-1">
                    <label htmlFor="startButtonCopy" className="mb-0">
                        Start Button Text:
                    </label>
                    <input
                        type="text"
                        id="startButtonCopy"
                        name="startButtonCopy"
                        className="p-2"
                        placeholder="Enter start button text"
                        value={assessmentState?.data?.buttonCopies?.START}
                        onChange={e => {
                            setAssessmentState(prev => ({
                                ...prev,
                                data: {
                                    ...prev.data,
                                    buttonCopies: {
                                        ...prev.data.buttonCopies,
                                        START: e.target.value,
                                    },
                                },
                            }));
                        }}
                    />
                </div>

                {/* Submit button text */}
                <div className="mb-3 d-flex flex-column gap-1">
                    <label htmlFor="submitButtonCopy" className="mb-0">
                        Submit Button Text:
                    </label>
                    <input
                        type="text"
                        id="submitButtonCopy"
                        name="submitButtonCopy"
                        className="p-2"
                        placeholder="Enter submit button text"
                        value={assessmentState?.data?.buttonCopies?.SUBMIT}
                        onChange={e => {
                            setAssessmentState(prev => ({
                                ...prev,
                                data: {
                                    ...prev.data,
                                    buttonCopies: {
                                        ...prev.data.buttonCopies,
                                        SUBMIT: e.target.value,
                                    },
                                },
                            }));
                        }}
                    />
                </div>

                {/* Next button text */}
                <div className="mb-3 d-flex flex-column gap-1">
                    <label htmlFor="nextButtonCopy" className="mb-0">
                        Next Button Text:
                    </label>
                    <input
                        type="text"
                        id="nextButtonCopy"
                        name="nextButtonCopy"
                        className="p-2"
                        placeholder="Enter next button text"
                        value={assessmentState?.data?.buttonCopies?.NEXT}
                        onChange={e => {
                            setAssessmentState(prev => ({
                                ...prev,
                                data: {
                                    ...prev.data,
                                    buttonCopies: {
                                        ...prev.data.buttonCopies,
                                        NEXT: e.target.value,
                                    },
                                },
                            }));
                        }}
                    />
                </div>

                {/* Action on complete */}
                <div className="mb-3 d-flex flex-column gap-1">
                    <label htmlFor="onCompleteAction" className="mb-0">
                        Action on Complete:
                    </label>
                    <input
                        type="text"
                        id="onCompleteAction"
                        name="onCompleteAction"
                        className="p-2"
                        placeholder="Enter action on complete"
                        value={assessmentState?.data?.onCompleteAction}
                        onChange={e => {
                            setAssessmentState(prev => ({
                                ...prev,
                                data: {
                                    ...prev.data,
                                    onCompleteAction: e.target.value,
                                },
                            }));
                        }}
                    />
                </div>

                <Button
                    variant="outline-secondary"
                    type="button"
                    className="w-100 mb-2"
                    onClick={() => setOpenJsonEditor(true)}
                >
                    Edit in JSON
                </Button>

                <Button variant="primary" type="submit" className="w-100">
                    {selectedAssessment && !isDuplicating
                        ? 'Save Changes'
                        : 'Create Assessment'}
                </Button>
            </Form>

            <AssessmentDataJsonModal
                isOpen={openJsonEditor}
                onClose={() => setOpenJsonEditor(false)}
                data={assessmentState.data}
                onSave={data => {
                    setAssessmentState(prev => ({
                        ...prev,
                        data,
                    }));
                    setDateError('');
                }}
            />
        </CaptainModal>
    );
};

export default BasicDataForm;
